import type { ProductCategoryData } from '@/types'

export const PRODUCT_CATEGORIES: ProductCategoryData[] = [
  {
    id: 'frames',
    label: 'Bike lines',
    description: 'The core Burton bike range. Raptor I is available to explore now; Felon I, Typhoon I, and Raider are coming soon.',
    products: [
      {
        id: 'frame-raptor-i',
        name: 'Raptor I',
        material: 'titanium',
        spec: 'Grade 9 Ti main triangle - Carbon rear - ML-optimised suspension',
        description: 'The current Burton enduro bike shown across the website. Built around aggressive terrain, machine-learned suspension, and a titanium/carbon chassis.',
        imageUrl: '/images/burton-tuatara-rs0002.jpg',
        builderFrameId: 'raptor-i',
      },
      {
        id: 'frame-felon-i',
        name: 'Felon I',
        material: 'carbon',
        spec: '200mm travel - Carbon chassis - ML-optimised suspension',
        description: 'Coming soon. The Burton downhill platform for bike-park speed, race tracks, and repeated high-impact runs.',
        imageUrl: '/images/bike-lines/hidden-felon.png',
        builderFrameId: 'felon-i',
      },
      {
        id: 'frame-typhoon-i',
        name: 'Typhoon I',
        material: 'carbon',
        spec: 'Lightweight chassis - 120-140mm travel - ML-optimised suspension',
        description: 'Coming soon. A faster, lighter platform for riders who want efficient pedalling without giving up control on technical trails.',
        imageUrl: '/images/bike-lines/hidden-typhoon.png',
        builderFrameId: 'typhoon-i',
      },
      {
        id: 'frame-raider',
        name: 'Raider',
        material: 'carbon',
        spec: 'Powered range - 170mm travel - ML-optimised suspension',
        description: 'Coming soon. The Burton E-Enduro line for bigger days, repeated descents, and custom handling with motor-assisted range.',
        imageUrl: '/images/bike-lines/hidden-raider.png',
        builderFrameId: 'raider',
      },
    ],
  },
]
